import { Box, Card, CardContent, Grid2, styled } from '@mui/material'
import React from 'react'

import CopyBox from '@/app/component/atom/copy-box'
import TabHeader from '@/app/component/atom/tab-header'
import { useGetOrganization } from '@/app/module/user/hooks/use-get-organization'

import { OrganizationFormSkeleton } from './organization-form'
import UpdateOrganization from './update-organization'

type Props = {
  orgId: number
}

const OrganizationInfo: React.FC<Props> = ({ orgId }) => {
  const { isLoading, isFetching } = useGetOrganization(orgId)

  const isSkeleton = isLoading || isFetching

  return (
    <Container>
      <TabHeader title="Organization Info" />
      <CopyContainer>
        <CopyBox inputVariant="standard" text={orgId.toString()} title="Organization ID" />
      </CopyContainer>
      <CardContent>
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 8 }}>
            {!isSkeleton && <UpdateOrganization orgId={orgId} />}
            {isSkeleton && (
              <Box p={2}>
                <OrganizationFormSkeleton />
              </Box>
            )}
          </Grid2>
        </Grid2>
      </CardContent>
    </Container>
  )
}

const Container = styled(Card)({
  position: 'relative',
})

const CopyContainer = styled('div')({
  '& .MuiFormControl-root': {
    position: 'absolute',
    top: 16,
    right: 16,
    margin: 0,
  },
})

export default OrganizationInfo
